import { render, staticRenderFns } from "./__inner_inventory_list.vue?vue&type=template&id=2cb3200f&"
import script from "./__inner_inventory_list.vue?vue&type=script&lang=js&"
export * from "./__inner_inventory_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports